export default "__VITE_ASSET__XhOKgTi3__"